<template>
  <div class="order">
    <fixed-tab :height="180">
      <div slot="content">
        <van-tabs
          class="van-tabs-simple"
          v-model="curOrderType"
          @click="requestData"
        >
          <van-tab
            v-for="(item, index) in orderTabs"
            :key="index"
            :title="item.title"
            :name="item.name"
          ></van-tab>
        </van-tabs>
        <van-tabs
          class="van-tabs-simple tabs-shadow"
          v-model="curStatus"
          @click="requestData"
        >
          <van-tab
            v-for="(item, index) in statusTabs"
            :key="index"
            :title="item.title"
            :name="item.name"
          ></van-tab>
        </van-tabs>
      </div>
    </fixed-tab>
    <Empty
      v-if="!list.length"
      :empty_type="{ name: '暂无订单' }"
      style="margin-top: 13.33333vw"
    />
    <List
      ref="list"
      url="/api/distribute/order"
      method="get"
      :params="params"
      :on-formatter="onFormatter"
      :on-getdata="onGetdata"
      :showText="list.length > 0"
    >
      <div slot="item" class="item-wrap">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="top">
            <p class="time">下单时间：{{ item.created_at | formatTime }}</p>
            <p class="status" :class="item.class">
              {{ item.descData.text.list }}
            </p>
          </div>
          <div class="content">
            <img class="cover" :src="item.cover_img" />
            <div class="info-wrap">
              <p class="title">{{ item.product_name }}</p>
              <div class="price-wrap">
                <p class="price">
                  <icon-price
                    size="middle"
                    :priceType="item.is_virtual"
                  ></icon-price>
                  {{ item.realPrice | toFixPrice }}
                </p>
                <div class="right">
                  分成:
                  <p class="price">
                    <icon-price
                      size="middle"
                      :priceType="item.is_virtual"
                    ></icon-price>
                    {{
                      (curOrderType == "distribute"
                        ? item.commission
                        : item.parent_commission) | toFixPrice
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <p>买家：{{ item.nickname }}</p>
            <div class="vmiddle" v-if="curOrderType == 'invite'">
              <img
                class="icon-person"
                src="~@/assets/images/distribute/person.png"
              />
              <span>{{ item.distributor_name }}</span>
            </div>
          </div>
        </div>
      </div>
    </List>
  </div>
</template>

<script>
export default {
  name: "Order",
  data() {
    return {
      curOrderType: this.$route.query.type || "distribute",
      orderTabs: [
        { title: "分销订单", name: "distribute" },
        { title: "邀请订单", name: "invite" },
      ],
      curStatus: 0,
      statusTabs: [
        { title: "全部", name: 0 },
        { title: "已支付", name: 1 },
        { title: "待支付", name: 2 },
        { title: "已完成", name: 3 },
        { title: "已关闭", name: 4 },
      ],
      params: {},
      list: [],
    };
  },
  created() {
    this.makeParams();
  },
  methods: {
    // on event
    onFormatter(data) {
      data.forEach(i => {
        i.realPrice = i.order_price + i.ship_price;
        // 获取订单状态描述
        i.descData = this.$pub.order.getListDescData(i);
        // 样式类 待支付 | 交易关闭，需要变黄色
        if (i.pay_status == 1 || i.order_status == 3) {
          i.class = "color-tag";
        }
      });
    },
    onGetdata(data) {
      this.list = data;
    },
    // other
    // 组装 params
    makeParams() {
      this.params = {};
      if (this.curOrderType == "invite") this.params.invite_order = 1;
      switch (this.curStatus) {
        case 0:
          this.params.order_status = 0;
          break;
        case 1:
          this.params.pay_status = 2;
          break;
        case 2:
          this.params.order_status = 1;
          this.params.pay_status = 1;
          break;
        case 3:
          this.params.order_status = 2;
          this.params.pay_status = 2;
          break;
        case 4:
          this.params.order_status = 3;
          break;
      }
    },
    // request
    requestData() {
      this.makeParams();
      this.$refs.list.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.order {
  .tabs-shadow {
    box-shadow: 0px 6px 30px 0px rgba(194, 207, 221, 0.17);
    /deep/ .van-tab {
      flex-basis: 20% !important;
    }
  }
  .item-wrap {
    padding: 20px;
    .item {
      background-color: #fff;
      box-shadow: 0px 0px 26px -4px rgba(0, 0, 0, 0.1);
      // border-radius: 20px;
      padding: 24px;
      font-size: 24px;
      margin-bottom: 24px;
      .top {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #f5f5f5;
        padding-bottom: 24px;
        .time {
          color: #333;
        }
        .status {
          color: #999;
          &.color-tag {
            color: #f6842f;
          }
        }
      }
      .content {
        display: flex;
        padding: 24px 0;
        border-bottom: 1px solid #f5f5f5;
        .cover {
          flex: none;
          margin-right: 20px;
          width: 194px;
          height: 114px;
          border-radius: 8px;
        }
        .info-wrap {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
          .title {
            font-size: 26px;
            color: #333;
            line-height: 32px;
          }
          .price-wrap {
            display: flex;
            justify-content: space-between;
            font-size: 28px;
            color: #666;
            .price {
              display: inline-block;
              &::first-letter {
                font-size: 20px;
              }
            }
          }
        }
      }
      .bottom {
        padding-top: 24px;
        font-size: 26px;
        color: #333;
        display: flex;
        justify-content: space-between;
        .icon-person {
          width: 26px;
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
